import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import RiskCategoryMaster from "./RiskCategoryMaster";
import RiskCategoryScoreMaster from "../RiskCategoryScoreMaster/RiskCategoryScoreMaster";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any,
  value: PropTypes.any,
};
function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    // display: "flex",
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    // width: "14%",
    "& .MuiTabs-indicator": {
      display: "none"
      //backgroundColor: "orange"
    }
  
  },
  tabPanels: {
    width: "86%",
  },
  Container: {
    marginTop:"20px"
  }
}));
const RiskCategoryTab = ({ classesChild }) => {
  const location = useLocation();
  const classes = useStyles();
  const params = useParams();
  let navigate = useNavigate();
  const [value, setValue] = React.useState(location?.state?.navigateTab ? location?.state?.navigateTab : 0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const dispatch = useDispatch();

  return (
    <div className={classes.root}>
      <Tabs
        orientation="Horizontal"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        // aria-label="Vertical tabs example"
        // className={classes.tabs}
      >
        <Tab label="Risk Category" {...a11yProps(0)} />
        <Tab label="Risk Category Score" {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={value} index={0} className={classes.Container}>
        <RiskCategoryMaster classes={classesChild} />
      </TabPanel>
      <TabPanel value={value} index={1} className={classes.Container}>
        <RiskCategoryScoreMaster classes={classesChild} />
      </TabPanel>
    </div>
  );
};

RiskCategoryTab.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  index: PropTypes.any,
  value: PropTypes.any,
};

export default RiskCategoryTab;
